import React from "react";
import PublicPageLayout from "@/components/PublicPageLayout";
import Seo, { pageSchema } from "@/components/Seo";
import { WhatsAppButton } from "@/components/WhatsAppFab";
import { WA_MESSAGES } from "@/lib/site";

const STEPS = [
  { n: "01", t: "Pick your package", d: "Choose GST, MCA or both — Pan India or a specific state / city / district / ROC." },
  { n: "02", t: "Sign up & submit request", d: "Create your Registry Feed account with your business email, and submit a subscription request with your desired filters." },
  { n: "03", t: "Get approved", d: "Once payment is confirmed on WhatsApp, our team activates your 30-day subscription and unlocks your dashboard." },
  { n: "04", t: "Daily downloads", d: "Each new upload appears in your dashboard as a daily file — preview, filter, download as CSV." },
  { n: "05", t: "Renew or extend", d: "Coming up on expiry? Request a renewal — we simply extend your existing window, no fresh onboarding needed." },
];

export default function HowItWorks() {
  const path = "/how-it-works";
  const title = "How It Works | Registry Feed Subscription Process";
  const description = "How to buy MCA / GST data from Registry Feed — from sign-up to daily downloads. A step-by-step look at our simple subscription process.";
  const bc = [{ name: "Home", path: "/" }, { name: "How It Works", path }];
  const jsonLd = pageSchema({ title, description, path, breadcrumbs: bc });
  return (
    <PublicPageLayout breadcrumbs={bc}>
      <Seo title={title} description={description} path={path} jsonLd={jsonLd} />
      <section className="mx-auto max-w-[1400px] px-4 sm:px-6 py-14 sm:py-20">
        <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight">How Registry Feed works</h1>
        <p className="mt-3 text-muted-foreground text-base sm:text-lg max-w-2xl">Five simple steps from sign-up to daily downloads.</p>

        <ol className="mt-10 space-y-4">
          {STEPS.map((s) => (
            <li key={s.n} className="rounded-lg border border-border bg-card p-5 flex gap-5">
              <div className="text-3xl font-heading font-black num text-primary">{s.n}</div>
              <div>
                <div className="font-heading font-semibold">{s.t}</div>
                <p className="mt-1.5 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="mt-10"><WhatsAppButton message={WA_MESSAGES.general} label="Start now on WhatsApp" /></div>
      </section>
    </PublicPageLayout>
  );
}
